import { z } from 'zod';

export const validationSeveritySchema = z.enum([
  'error',
  'warning',
  'info',
]);

export const validationIssueSchema = z.object({
  severity: validationSeveritySchema,
  code: z.string().min(1),
  path: z.string(),
  message: z.string().min(1),
  suggestedFix: z.string().min(1).optional(),
}).strict();

export type ValidationSeverity = z.infer<typeof validationSeveritySchema>;
export type ValidationIssue = z.infer<typeof validationIssueSchema>;
